import { Box, Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { TableColumn } from '@app/components/common/table';
import { ConfirmRemoveDialog } from '@app/components/common';


export const useColumns = ({
  onEdit,
  onRemove,
}: {
  onEdit: (id: string) => void;
  onRemove: (id: string) => void;
}): TableColumn[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'key',
      label: 'Ключ',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'value',
      label: 'Значение',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <Box whiteSpace='pre-wrap' style={{ wordBreak: 'break-all' }}>
              {value.toString()}
            </Box>
          );
        },
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id) => {
          return (
            <Flex gap={2}>
              <IconButton name="edit" onClick={() => onEdit(id)} aria-label="edit">
                <MdEdit />
              </IconButton>
              <ConfirmRemoveDialog onRemove={() => onRemove(id)} text="Удалить?" />
            </Flex>
          );
        },
      },
    },
  ];
};
